import {EventType, MatrixClient, MsgType} from 'matrix-js-sdk';

export const sendTextMessage = async (
  matrixClient: MatrixClient,
  messageText: string,
  currentMatrixRoomId?: string,
  roomId?: string
): Promise<void> => {
  try {
    const roomIdToUse = roomId || currentMatrixRoomId;

    if (roomIdToUse) {
      await matrixClient.sendEvent(roomIdToUse, EventType.RoomMessage, {
        msgtype: MsgType.Text,
        body: messageText
      });
    }
  } catch (error) {
    console.error('Failed to send the message', error);
    throw error;
  }
};
